<cx-accordion [title]="'Especificações'" [icon]="'list'" [isActive]="true">
  <div class="table">
    <div class="table-line">
      <span class="table-attribute">{{ 'product.ean' | translate }}</span>
      <span class="table-value">{{ product.sapEAN }}</span>
    </div>
    <div class="table-line">
      <span class="table-attribute">{{ 'product.SKU' | translate }}</span>
      <span class="table-value">{{ product.code }}</span>
    </div>
    <div class="table-line">
      <span class="table-attribute">{{ 'product.brand' | translate }}</span>
      <span class="table-value">{{ product.brand }}</span>
    </div>
    <div class="table-line">
      <span class="table-attribute">{{ 'product.origin' | translate }}</span>
      <span class="table-value">{{ product.countryOrigin }}</span>
    </div>
    <div class="table-line">
      <span class="table-attribute">{{ 'product.ncm' | translate }}</span>
      <span class="table-value">{{ product.ncm }}</span>
    </div>
  </div>
</cx-accordion>
